import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import CourseCreatorService from '../../../../shared/util/course-creator.service';
import { Store } from '@ngrx/store';
import { State } from '../../../../shared/core/state';
import { Resource } from '../../../../shared/core/state/resource/models';

@Component({
    selector: 'black-accordion-resource',
    templateUrl: './accordion-resource.component.html',
    styleUrls: ['./accordion-resource.component.css'],
    standalone: false
})
export class AccordionResourceComponent implements OnInit {
  private courseCreatorService = inject(CourseCreatorService);
  private store = inject<Store<State>>(Store);

  @Input()
  item = {
    id: '',
    icon: '',
    link: '',
    title: '',
  };

  @Input()
  referenceId = 0;

  @Output()
  deleteEvent = new EventEmitter<string>();

  resourceItem: Resource | null = null;

  ngOnInit(): void {
    const courseItem = this.courseCreatorService.getCourseItem(
      this.referenceId
    );
    courseItem.then((item) => {
      const selectedItem = item?.contents.find(
        (content) => this.item.id === content.id
      );
      this.store
        .select((state) => state.resources.resourceItems)
        .subscribe((items) => {
          const selectedResource = items.find(
            (item) => item._id === selectedItem?.resourceId
          );
          this.resourceItem = selectedResource ?? null;
        });
    });
  }

  deleteItem(resourceId: string) {
    this.deleteEvent.emit(resourceId);
  }
}
